document.addEventListener("DOMContentLoaded", function () {

  // ===============================
  // INIT SWIPER
  // ===============================
  const swiperHome = new Swiper(".banner_swiper", {
    loop: true,
    speed: 1000,
    effect: "slide",
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    pagination: {
      el: ".banner_pagination",
      clickable: true,
    },
  });

  // ===============================
  // ELEMENTS
  // ===============================
  const playBox = document.querySelector(".PlayBox");
  let isPlaying = true;

  // ===============================
  // PAUSE / RESUME LOGIC
  // ===============================
  playBox.addEventListener("click", function () {

    const activeBullet = document.querySelector(
      ".HomeBanner .swiper-pagination-bullet-active::after"
    );

    if (isPlaying) {
      // STOP SWIPER
      swiperHome.autoplay.stop();

      // PAUSE PROGRESS BAR
      document
        .querySelectorAll(".HomeBanner .swiper-pagination-bullet::after")
        .forEach(() => {});

      document.documentElement.style.setProperty(
        "--swiper-play-state",
        "paused"
      );

    } else {
      // START SWIPER
      swiperHome.autoplay.start();

      // RESUME PROGRESS BAR
      document.documentElement.style.setProperty(
        "--swiper-play-state",
        "running"
      );
    }

    isPlaying = !isPlaying;
  });

});
